import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ChevronRight } from 'lucide-react';
// Broom glyph from Font Awesome (via react-icons) — lucide does not ship one.
import { FaBroom } from 'react-icons/fa';
export function QuickActionCTAs() {
  return <div className="mb-8" data-id="element-907">
      <h2 className="text-sm font-semibold text-foreground mb-3" data-id="element-908">
        Azioni rapide
      </h2>
      <div className="grid grid-cols-2 gap-3" data-id="element-909">
        {/* Pulizie */}
        <Link to="/pulizie" className="bg-white border border-border rounded-xl p-3 flex items-center gap-3 hover:bg-muted/50 hover:border-foreground/20 transition-colors" data-id="element-910">
          <div className="w-9 h-9 rounded-full bg-muted flex items-center justify-center flex-shrink-0" data-id="element-911">
            <FaBroom size={16} className="text-foreground" data-id="element-912" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-913">
            <div className="font-medium text-foreground text-sm leading-tight" data-id="element-914">
              Pulizie
            </div>
            <div className="text-xs font-medium leading-tight text-coral mt-0.5" data-id="element-915">
              3 condivisibili
            </div>
          </div>
          <ChevronRight size={16} className="text-muted-foreground flex-shrink-0" data-id="element-916" />
        </Link>

        {/* Segnalazioni e manutenzione */}
        <Link to="/segnalazioni" className="bg-white border border-border rounded-xl p-3 flex items-center gap-3 hover:bg-muted/50 hover:border-foreground/20 transition-colors" data-id="element-917">
          <div className="w-9 h-9 rounded-full bg-muted flex items-center justify-center flex-shrink-0" data-id="element-918">
            <AlertTriangle size={18} className="text-foreground" data-id="element-919" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-920">
            <div className="font-medium text-foreground text-sm leading-tight" data-id="element-921">
              Segnalazioni e manutenzione
            </div>
            <div className="text-xs font-medium leading-tight text-coral mt-0.5" data-id="element-922">
              3 aperte
            </div>
          </div>
          <ChevronRight size={16} className="text-muted-foreground flex-shrink-0" data-id="element-923" />
        </Link>
      </div>
    </div>;
}